// Dashboard-editable settings, one item in the table (`PK: config`, `SK: config`).
// Anything missing falls back to the defaults below, so the item need not exist.
export const CONFIG_ID = "main"; // the id used in /api/config/{id}
export const CONFIG_DEFAULTS = {
  captureRetentionDays: 90,
  internalRetentionDays: 30,
  floodLimitPerMinute: 60,
  floodSampleEvery: 10,
} as const;

export type StoredConfig = {
  captureRetentionDays: number; // TTL stamped on new captures/chunks; existing items keep theirs
  internalRetentionDays: number; // TTL on log-pile's own error notes (types/internal.ts)
  // Flood gate (backend/utils/flood.ts): past this many hits on one group in
  // a minute, only every Nth capture body is stored; all are counted.
  floodLimitPerMinute: number;
  floodSampleEvery: number;
  updatedAt?: string;
  updatedBy?: string; // doridium user id
};

export type UpdateConfigInput = {
  id: typeof CONFIG_ID;
  captureRetentionDays?: number; // 1..3650
  internalRetentionDays?: number; // 1..3650
  floodLimitPerMinute?: number; // 1..100000
  floodSampleEvery?: number; // 1..1000
};

export const CONFIG_LIMITS = {
  minRetentionDays: 1,
  maxRetentionDays: 3650,
  minFloodLimit: 1,
  maxFloodLimit: 100_000,
  minSampleEvery: 1,
  maxSampleEvery: 1_000,
} as const;

export type ConfigNumberField = "captureRetentionDays" | "internalRetentionDays" | "floodLimitPerMinute" | "floodSampleEvery";
export const CONFIG_FIELD_RANGES: Record<ConfigNumberField, [number, number]> = {
  captureRetentionDays: [CONFIG_LIMITS.minRetentionDays, CONFIG_LIMITS.maxRetentionDays],
  internalRetentionDays: [CONFIG_LIMITS.minRetentionDays, CONFIG_LIMITS.maxRetentionDays],
  floodLimitPerMinute: [CONFIG_LIMITS.minFloodLimit, CONFIG_LIMITS.maxFloodLimit],
  floodSampleEvery: [CONFIG_LIMITS.minSampleEvery, CONFIG_LIMITS.maxSampleEvery],
};
